module.exports = __webpack_public_path__ + "img/Manila Bay Clean Up Drive 3.e6f58cf7.jpg";